module.exports = "images/france-4.57ecb2e2.png";